import { v4 } from 'uuid';

export abstract class AuditBase {

  /**
   * Unique ID of object instance.
   */
  private _objectId: string;

  constructor() {
    this._objectId = `${new.target.name}_${v4()}`;
  }

  /**
   * Getter for unique ID of object instance.
   */
  get objectId() {
    return this._objectId;
  }
}
